import Center from "@/Components/Base/Center";
import KioskLogo from "./KioskLogo";
import useBranch from "@/shared/atoms/useBranch";
import { useCart } from "@/shared/hooks/useCartHook";
import usePaymentHook from "@/shared/hooks/usePaymentHook";
import usePosOrderPost from "@/shared/mutations/pos/usePosOrderPost";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";

const KioskPayments = () => {
  const { mutateAsync } = usePosOrderPost();
  const [branch] = useBranch();
  const [cart] = useCart();
  const { t: tCommon } = useTranslation("");
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const { kioskPayments } = usePaymentHook();

  const checkout = (paymentMethod: number) => {
    mutateAsync({
      order_user: {},
      order_information: {
        branch_id: branch.item_id,
        loyalty_ledger_points: 0,
        remarks: "",
        payment_method_id: paymentMethod,
        is_online_link_payment: paymentMethod === 2 ? true : undefined,
        delivery_method_id: parseInt(id),
        tip: "",
        delivery_cost: "",
        source: 19,
        hand_over_time: "",
        hand_over_is_asap: true,
      },
      cart: cart.map((item) => {
        const isCustomCartItem = item.item_id < 0;
        return {
          ...item,
          price_per_target_value: undefined,
          menu_item_id: isCustomCartItem ? undefined : item.item_id,
          menu_item_price: isCustomCartItem ? item.price : undefined,
          sub_content: item?.sub_content?.map((sub) => ({
            ...sub,
            menu_item_id: sub.item_id,
            item_id: undefined,
            price_per_target_value: undefined,
          })),
          price: undefined,
          item_id: undefined,
          vat_percentage: 9,
        };
      }),
    });
  };

  useEffect(() => {
    if (cart.length === 0) {
      return history.push("/kiosk");
    }
  }, [cart]);

  return (
    <Center>
      <div>
        <div className="mb-[2rem]">
          <div>
            <KioskLogo height="auto" width="50rem" />
          </div>
        </div>
        <h1 className="mb-16 text-[6rem]">{tCommon("chooseAPayment")}</h1>
        {kioskPayments.map((payment) => (
          <div
            key={payment.value}
            className="flex h-1609 w-120 flex-col items-center justify-center rounded-[3rem] bg-[white] p-16"
          >
            <div
              onClick={() => checkout(payment.value)}
              className="text-[3rem]"
              style={{ fontWeight: "900" }}
            >
              {tCommon(payment.translationKey)}
            </div>
          </div>
        ))}
      </div>
    </Center>
  );
};

export default KioskPayments;
